import React from 'react';
import { Columns } from '@components/Columns';
import {
  StyledWeddingWebsiteCross,
  StyledCenterBody,
  ButtonsContainer,
  FeatureText,
  WeddingWebsiteTextPairing,
  StyledTextColumn,
  FeatureImage,
  LearnMoreWrapper,
} from './WeddingWebsite.styles';
import ReactHtmlParser from 'react-html-parser';
import { Flex } from '@components/Flex';
import { CloudImage } from '@components/CloudImage';
import { Button } from '@components/Button';
import { getCreateEventUrl } from '@utils/urlHelpers.util';
import { useTranslation } from 'react-i18next';

export const WeddingWebsiteSection: React.FC = () => {
  const { t } = useTranslation('hotelRoomBlocks');
  const weddingWebsiteSectionData = t('weddingWebsiteSection');

  return (
    <StyledWeddingWebsiteCross as="section" id="Hotel_Room_Blocks_Wedding_Website">
      <StyledCenterBody paddingTop={[12]} paddingBottom={[12]}>
        <StyledTextColumn centered>
          <Columns.Column width={12}>
            <Flex flexDirection={'column'} alignItems={'center'} paddingBottom={[10]}>
              <WeddingWebsiteTextPairing
                alignment="center"
                eyebrow={weddingWebsiteSectionData.eyeBrow}
                eyebrowColor="humanaDark4"
                eyebrowVariant="sectionEyeBrow20"
                eyebrowTagName="h2"
                title={weddingWebsiteSectionData.title}
                titleVariant="hed56"
                titleColor="humanaDark6"
                titleTagName="h2"
                body={weddingWebsiteSectionData.content}
                bodyVariant="dek24"
                bodyColor="neutra6"
                bodyTagName="p"
              />
              <ButtonsContainer marginTop={[10]}>
                <Button
                  id="hotelRoomBlocksWeddingWebsiteGetStartedBtn"
                  forwardedAs="a"
                  href={getCreateEventUrl('hotel-room-blocks')}
                  variant="secondary"
                >
                  {weddingWebsiteSectionData.buttonCreateYourWebsite}
                </Button>
                <LearnMoreWrapper
                  id="connected-learn-more"
                  href="/wedding-website"
                  typography={'featureHed20'}
                  variant={'primary'}
                  hasChevron
                >
                  {weddingWebsiteSectionData.buttonLearnMore}
                </LearnMoreWrapper>
              </ButtonsContainer>
            </Flex>
          </Columns.Column>
        </StyledTextColumn>
        <Columns marginTop={8} marginBottom={10} centered verticalAlign="flex-start">
          {weddingWebsiteSectionData.featuresData.map((item, index) => (
            <Columns.Column key={index} width={3}>
              <Flex alignItems="center" justifyContent="center" flexDirection="column">
                <FeatureImage>
                  <CloudImage src={item.image} width={32} height={32} />
                </FeatureImage>
                <FeatureText textAlign="center" tagName="h2" variant="featureHed17" color="humanaDark6">
                  {ReactHtmlParser(item.title)}
                </FeatureText>
              </Flex>
            </Columns.Column>
          ))}
        </Columns>
        <Columns marginBottom={10} centered>
          <Columns.Column width={12}>
            <CloudImage optimization="none" src={weddingWebsiteSectionData.image} width={'100%'} />
          </Columns.Column>
        </Columns>
      </StyledCenterBody>
    </StyledWeddingWebsiteCross>
  );
};
